export default __webpack_public_path__ + "static/media/kestrel9.82910c40.jpg";